import styled from 'styled-components'

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px;
`

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 16px;
`

export const BackButton = styled.div`
  padding: 8px 8px 16px;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  gap: 10px;
  .anticon {
    font-size: 18px;
    cursor: pointer;
  }
`

export const FormButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 42px;
  gap: 8px;
`

export const SettingWrapper = styled.div`
  display: flex;
  background-color: #fff;
  border-radius: 8px;
  font-size: 14px;
`

export const BasicSettingWrapper = styled.div`
  width: 320px;
  padding: 24px;
  border-right: 1px solid rgba(0,0,0,.1);
  
  .ant-upload-wrapper .ant-upload-select {
    width: 100%;
  }
  .ant-tooltip-disabled-compatible-wrapper {
    display: block !important;
  }
`

export const CustomSettingWrapper = styled.div`
  width: calc(100% - 320px);
  padding: 24px;

  .ant-empty-description {
    color: rgba(0,0,0,.3);
  }
`

export const SubTitle = styled.div`
  font-weight: 600;
  padding-bottom: ${({ section }) => section ? '8px' : '24px'};
  cursor: default;
`
